import { Message, Schedule_Execution } from "../../../js/parsegenerated";
import { MessageData } from "../../messages";

export function getMessageType(message: Message) {
  const data: MessageData = message.data;
  if (!data?.origin) return "message";
  if (data.origin.classname === Schedule_Execution.className) return "schedule";
  return "ticket";
}
